import styled from 'styled-components'

export const TimelineInstruction = styled.div`
    padding-bottom: 32px;

    > h4 {
        font-size: 16px;
        font-weight: 600;
        line-height: 26.4px;
        padding: 0 0 16px;
        margin: 0px;
    }
`

export const TimelineContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`

export const TimelineDetail = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;

    >p{
        margin: 0px;
        font-size: 14px;
        line-height: 23.1px;
    }
`
